/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */

export type OrthoApprovalStatus =
  (typeof OrthoApprovalStatus)[keyof typeof OrthoApprovalStatus];

export const OrthoApprovalStatus = {
  approved: "approved",
  pending: "pending",
  processing: "processing",
  rejected: "rejected",
  uploading: "uploading",
} as const;
